'use client';
import { useEffect } from 'react';
import styles from '../styles/Brief.module.css';
import BlockRendererClient from '@/app/_components/BlocksRendererCustom';
import YouTubeVideo from './YouTube.client';
import { type BlocksContent } from '@strapi/blocks-react-renderer';

const isBlocksContentEmpty = (content: BlocksContent) => {
    if (!content || !Array.isArray(content)) return true;

    // 检查是否所有段落的文本都为空
    return content.every((block) => {
        if (block.type === 'paragraph') {
            return block.children.every((child: any) => child.type === 'text' && (!child.text || child.text === '__placeholder__'));
        }
        return false;
    });
};

export default function Brief({ data }: { data: any }) {
    const { BoxName, Brief, DySections } = data ?? {};

    const {
        //prettier-ignore
        // Content = '',
        Content_2 = '',
        Video = { data: null },
        VideoIfYoutube,
        VideoYoutubeID,
        MOQ = '',
    } = Brief ?? {};
    const assetsBaseUrl = process.env.NEXT_PUBLIC_STRAPI_URL_EXTERNAL;
    // const VideoUrl = Video.data?.attributes?.url;
    const VideoUrl = Video?.data?.attributes?.url || null;

    useEffect(() => {
        const handleScroll = (id: string) => {
            const section = document.getElementById(id);
            if (section) {
                const yOffset = -75;
                const y = section.getBoundingClientRect().top + window.scrollY + yOffset;
                window.scrollTo({ top: y, behavior: 'smooth' });
            }
        };

        const addClickListener = (elementId: string, targetId: string) => {
            const element = document.getElementById(elementId);
            if (element) {
                element.addEventListener('click', () => handleScroll(targetId));
            }
        };

        if (DySections?.length) {
            DySections.forEach((_: any, index: number) => {
                const scrollId = `scroll-${index + 1}`;
                const sectionId = `section-${index + 1}`;
                addClickListener(scrollId, sectionId);
            });
        }

        return () => {
            if (DySections?.length) {
                DySections.forEach((_: any, index: number) => {
                    const scrollId = `scroll-${index + 1}`;
                    const sectionId = `section-${index + 1}`;
                    const element = document.getElementById(scrollId);
                    if (element) {
                        element.removeEventListener('click', () => handleScroll(sectionId));
                    }
                });
            }
        };
    }, [DySections]);

    return (
        <section className={`mx-auto max-w-[1100px] py-16`}>
            <section className={`grid grid-cols-1 md:grid-cols-2 gap-[40px] mb-10`}>
                <div className={`col-span-1`}>
                    <h1 className={`capitalize`}>{BoxName}</h1>
                    {/* <p>{Content}</p> */}
                    {!isBlocksContentEmpty(Content_2) && <BlockRendererClient content={Content_2} />}
                    <p>
                        <span className={`text-gray-700`}>Our minimum customized quantity:</span>
                        <br />
                        <span className={`font-medium`}>{MOQ}</span>
                    </p>
                    {(VideoUrl || (VideoIfYoutube && VideoYoutubeID)) && <p className="font-bold">Video Show:</p>}
                </div>
                <div className={`col-span-1 bg-[#F7F7F7] py-10 px-10`}>
                    <p className={`font-bold mb-4`}>Table of Contents:</p>
                    <ol className={styles.TitleList}>
                        {DySections.map((item: any, index: number) => {
                            const displayIndex = index + 1;
                            return (
                                <li id={`scroll-${displayIndex}`} key={`item-${item.id}-${displayIndex}`}>
                                    {item.Title}
                                </li>
                            );
                        })}
                    </ol>
                </div>
            </section>
            {(VideoIfYoutube && VideoYoutubeID) || VideoUrl ? (
                <>
                    {VideoIfYoutube && VideoYoutubeID ? (
                        <YouTubeVideo videoId={VideoYoutubeID} />
                    ) : (
                        <div className={styles.VideoContainer}>
                            <video controls autoPlay muted>
                                <source src={`${assetsBaseUrl}${VideoUrl}`} type="video/mp4" />
                                Your browser does not support the video tag.
                            </video>
                        </div>
                    )}
                </>
            ) : null}
        </section>
    );
}
